<script lang="ts">
  import { currentRoute } from "../store";

  function navigate(route: string, e: Event): void {
    e.preventDefault();
    $currentRoute = route;
  }
</script>

<div class="w-full">
  <!-- Banner Section -->
  <div
    class="relative w-full h-[450px] flex items-center justify-center overflow-hidden shadow-inner border-b border-gray-200"
  >
    <img
      class="absolute inset-0 w-full h-full object-cover opacity-90 scale-105"
      src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80"
      alt="About Us Banner"
    />
    <div class="absolute inset-0 bg-sky-900/70"></div>
    <div class="relative z-10 text-center text-white px-4">
      <h1
        class="text-7xl font-black uppercase tracking-widest drop-shadow-2xl mb-4 text-amber-400"
      >
        About Us
      </h1>
      <p
        class="text-3xl font-medium tracking-wide max-w-3xl mx-auto drop-shadow-lg text-sky-50"
      >
        Your premier destination for global shopping.
      </p>
    </div>
  </div>

  <!-- Content Section -->
  <div
    class="max-w-7xl mx-auto px-6 py-20 flex flex-col md:flex-row items-center gap-16"
  >
    <div class="w-full md:w-1/2 relative">
      <div
        class="absolute inset-0 bg-sky-400 rounded-3xl transform rotate-3 scale-105 opacity-50"
      ></div>
      <img
        src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
        alt="Office"
        class="relative z-10 rounded-3xl shadow-2xl border-8 border-white transform hover:rotate-0 hover:scale-105 transition duration-500"
      />
    </div>
    <div class="w-full md:w-1/2">
      <p class="text-sky-500 font-black tracking-widest text-xl uppercase mb-3">
        <i class="fa-solid fa-bookmark mr-2"></i> Our Story
      </p>
      <h2 class="text-6xl font-black text-gray-800 mb-8 leading-tight">
        Welcome to <span class="block text-amber-500 mt-2">Global Bazar</span>
      </h2>
      <p class="text-xl text-gray-600 mb-6 leading-relaxed font-medium">
        Founded with a vision to connect consumers with high-quality products
        from around the globe, Global Bazar is committed to excellence. Our
        platform offers a seamless shopping experience with top brands,
        guaranteed authenticity, and unparalleled customer service.
      </p>
      <p class="text-xl text-gray-600 mb-10 leading-relaxed font-medium">
        Whether you're looking for the latest electronics, trendy fashion
        apparel, or essential home goods, our carefully curated selections are
        designed to meet your every need. Explore our diverse catalog and
        experience the difference today.
      </p>
      <button
        on:click={(e) => navigate("Products", e)}
        class="bg-sky-500 text-white font-black text-lg py-4 px-12 rounded-full hover:bg-amber-400 hover:text-black transition duration-300 shadow-xl hover:-translate-y-2 hover:shadow-2xl uppercase tracking-widest"
      >
        Start Shopping Now
      </button>
    </div>
  </div>
</div>
